// 필드(ARPG 모드) 열림 판정 하나로 감싼다. 정본은 환생 상태(레인 R: dungeonhero.rebirth.v1 · GameView.rebirth)의 회차 ≥ 1 +
// 공개 스위치(content/items REBIRTH[1].released). 아직 환생 상태가 없으므로 출시 전 확인 쿼리 ?modes=1(스펙 1장) 또는 ?field=1로 연다.
// 통합 때 지휘가 rebirthCycle 인자를 R의 상태로 잇는다(이 함수 하나만 바꾸면 문·월드 맵·명령이 모두 따른다).
import { REBIRTH } from '../content/items';
import { previewQueryAllowedHere } from '../previewFlags';

let queryCache: boolean | null = null;
/** 주소 쿼리 ?modes=1 · ?field=1 — 운영 호스트에서는 무시(previewFlags). 테스트는 setFieldQueryOverride로 바꾼다 */
export function fieldQueryFlag(): boolean {
  if (queryCache !== null) return queryCache;
  let on = false;
  try {
    const s = typeof location !== 'undefined' ? location.search : '';
    const p = new URLSearchParams(s);
    on = (p.get('modes') === '1' || p.get('field') === '1') && previewQueryAllowedHere();
  } catch { on = false; }
  return (queryCache = on);
}
/** 시험용: 쿼리 판정을 덮어쓴다(null = 다시 주소에서 읽는다) */
export function setFieldQueryOverride(v: boolean | null): void { queryCache = v; }

/**
 * 이 영웅이 필드 문을 볼 수 있는지. view.rebirth(레인 R)가 생기면 회차를 읽는다.
 * 회차 ≥ 1이고 ARPG 모드가 공개됐거나, 출시 전 확인 쿼리가 있으면 true
 */
export function fieldUnlocked(view?: { readonly rebirth?: { readonly cycle: number } | null } | null): boolean {
  if (fieldQueryFlag()) return true;
  const cycle = view?.rebirth?.cycle ?? 0;
  if (cycle < 1) return false;
  // 마을에서 틱마다 부를 수 있게 클로저 없이 찾는다
  for (let i = 0; i < REBIRTH.length; i++) if (REBIRTH[i].cycle === 1) return REBIRTH[i].released;
  return false;
}
